'use strict';
import * as $j_app$002edata$002e$002dNot$002dAn$002dE$002dP$002dS$002dCode$002dError from "./app.data.-Not-An-E-P-S-Code-Error.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_NotAnEPSCodeError$() {
  this.Lapp_data_NotAnEPSCodeError$__f_EPSr2Regex = null;
  this.Lapp_data_NotAnEPSCodeError$__f_validatorRule = null;
  $n_Lapp_data_NotAnEPSCodeError$ = this;
  this.Lapp_data_NotAnEPSCodeError$__f_EPSr2Regex = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_s_util_matching_Regex__T__sci_Seq__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_matching_Regex(), "(?i)^[a-z0-9\\+]{6}-[a-z0-9\\+]{6}-[a-z0-9\\+]{6}$", $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$());
  var f = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((str) => {
    if (this.Lapp_data_NotAnEPSCodeError$__f_EPSr2Regex.matches__jl_CharSequence__Z(str)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      $m_Lapp_data_NotAnEPSCodeError$();
      var value = new $j_app$002edata$002e$002dNot$002dAn$002dE$002dP$002dS$002dCode$002dError.$c_Lapp_data_NotAnEPSCodeError(str);
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }
  }));
  this.Lapp_data_NotAnEPSCodeError$__f_validatorRule = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lyantl_ValidatorRule$$anon$5(f);
}
export { $c_Lapp_data_NotAnEPSCodeError$ as $c_Lapp_data_NotAnEPSCodeError$ };
$c_Lapp_data_NotAnEPSCodeError$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_NotAnEPSCodeError$.prototype.constructor = $c_Lapp_data_NotAnEPSCodeError$;
/** @constructor */
function $h_Lapp_data_NotAnEPSCodeError$() {
}
export { $h_Lapp_data_NotAnEPSCodeError$ as $h_Lapp_data_NotAnEPSCodeError$ };
$h_Lapp_data_NotAnEPSCodeError$.prototype = $c_Lapp_data_NotAnEPSCodeError$.prototype;
$c_Lapp_data_NotAnEPSCodeError$.prototype.fromProduct__s_Product__Lapp_data_NotAnEPSCodeError = (function(x$0) {
  var code$1 = x$0.productElement__I__O(0);
  return new $j_app$002edata$002e$002dNot$002dAn$002dE$002dP$002dS$002dCode$002dError.$c_Lapp_data_NotAnEPSCodeError(code$1);
});
$c_Lapp_data_NotAnEPSCodeError$.prototype.fromProduct__s_Product__O = (function(p) {
  return this.fromProduct__s_Product__Lapp_data_NotAnEPSCodeError(p);
});
var $d_Lapp_data_NotAnEPSCodeError$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_NotAnEPSCodeError$, "app.data.NotAnEPSCodeError$", ({
  Lapp_data_NotAnEPSCodeError$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1
}));
export { $d_Lapp_data_NotAnEPSCodeError$ as $d_Lapp_data_NotAnEPSCodeError$ };
var $n_Lapp_data_NotAnEPSCodeError$;
function $m_Lapp_data_NotAnEPSCodeError$() {
  if ((!$n_Lapp_data_NotAnEPSCodeError$)) {
    $n_Lapp_data_NotAnEPSCodeError$ = new $c_Lapp_data_NotAnEPSCodeError$();
  }
  return $n_Lapp_data_NotAnEPSCodeError$;
}
export { $m_Lapp_data_NotAnEPSCodeError$ as $m_Lapp_data_NotAnEPSCodeError$ };
//# sourceMappingURL=app.data.-Not-An-E-P-S-Code-Error$.js.map
